<template>
  <!-- <span> -->
  <!-- v-model="value" -->
  <!-- <v-text-field
      outline
      readonly
      :dark="dark"
      :id="input_id"
      slot="activator"
      :label="$t(label)"
      @click="show = !show"
      :clearable="clearable"
      :single-line="singleLine"
      :placeholder="placeholder"
      :hide-details="hideDetails"
      @input="$emit('input', null)"
      :prepend-icon="hasIcon ? 'event' : ''"
      :prepend-inner-icon="prependInnerIcon"
      :value="dateValue | persianDateFilter(true, isTime)"
    /> -->
  <!-- append-to="#app" -->
  <!-- :show="show" -->
  <picker
    popover
    editable
    ref="pck"
    showNowBtn
    :type="type"
    locale="fa,en"
    color="#13aa52"
    v-model="dateValue"
    style="width: 100%"
    @close="show = false"
    class="v-input picker"
    :clearable="clearable"
    :format="timeFormat.format"
    :class="{ 'data-picker': !hideDetails }"
    :display-format="timeFormat.displayFormat"
    :placeholder="`${placeholder} (${formatLabel})`"
    :title="`${placeholder || label} (${formatLabel})`"
  />
</template>
<script>
import picker from "./picker/VuePersianDatetimePicker.vue";
export default {
  name: "datePicker",
  inheritAttrs: false,
  components: { picker },
  props: {
    label: {
      default: "date",
    },
    input_id: { required: true },
    value: {
      required: true,
    },
    disabled: {
      default: false,
    },
    type: {
      default: "date",
    },
    clearable: {
      default: false,
    },
    tabindex: { default: undefined },
    minDate: {
      default: null,
    },
    dark: {
      default: false,
    },
    singleLine: {
      default: false,
    },
    hideDetails: {
      default: false,
    },
    hasIcon: {
      default: false,
    },
    readonly: {
      default: false,
    },
    prependInnerIcon: {
      default: undefined,
    },
    placeholder: {
      default: () => new Date().toLocaleDateString("en-ca"),
    },

    errorMessages: {
      default: null,
    },
  },
  data: () => ({ show: false }),
  methods: {
    clicked() {
      this.show = !this.show;
    },
  },
  computed: {
    formatLabel() {
      if (this.isTime) return "HH:mm:ss";
      return "YYYY/MM/DD";
      // let localeData = this.$refs.pick.localeData || { name: "fa" };
      // return localeData.name == "fa" ? "YYYY/MM/DD" : "YYYY-MM-DD";
    },
    dateValue: {
      get() {
        return this.value;
      },
      set(value) {
        if (this.value != value) this.$emit("input", value);
      },
    },
    isTime() {
      return this.type == "time";
    },
    timeFormat() {
      if (this.isTime)
        return {
          format: "HH:mm:ss",
          displayFormat: "HH:mm:ss",
        };
      return { format: "YYYY-MM-DD", displayFormat: "jYYYY/jMM/jDD" };
    },
  },
};
</script>
<style scoped>
.picker {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}
.data-picker {
  padding-bottom: 28px !important;
}

.picker.py-0 {
  padding-bottom: 18px !important;
  padding-top: 0px !important;
}
</style>